import React, { useState, useEffect } from 'react';
import Logo from '../../../general/logo';
import UserMenu from '../../../general/Menu';
import styles from './styles.module.scss';

import { Layout } from 'antd';

const { Header, Content, Footer, Sider } = Layout;

interface TopNavProps {
  type: string;
}

const TopNav: React.FC<TopNavProps> = ({ type }: TopNavProps): JSX.Element => {
  return (
    <Header
      className={styles.header}
      style={{
        background: 'white',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 100,
        paddingLeft: '18px',
      }}
    >
      <div
        className={styles.logo}
        style={{ display: type === 'user' ? '' : 'none' }}
      >
        <a href="/">
          <Logo {...{ size: 'medium' }} />
        </a>
      </div>
      <div className={styles.menu}>
        <UserMenu />
      </div>

      {/* <div className="" style={{"padding":"0px !important","height":"90px"}}><Menu/></div> */}
    </Header>
  );
};

export default TopNav;
